import React, { useState, useEffect } from 'react'

export default function Input({ name, value, placeholder, onChange, className}){
	const [input, setInput] = useState(value)
	let timer = null

	const handleChange = (e) => {
		const { value } = e.target
		setInput(value)
	}

	useEffect(()=>{
		clearTimeout(timer)
		if (input !== value && onChange) {
			timer = setTimeout(() => onChange({name,input}), 300)
		}
		return () => clearTimeout(timer)
	}, [input])

	useEffect(()=>{
		if (input !== value) {
			setInput(value)
		}
	}, [value])

	return(
		<input name={name}
		       value={input}
		       className={className}
		       placeholder={placeholder}
		       type="text"
		       autoComplete="off"
		       onChange={handleChange}
			/>
	)
}